import React from 'react'
import Container from '@material-ui/core/Container'
import {Townhall} from 'Event/template/Townhall'
import {TechCheckProps} from 'Event/Step3/TechCheck'
import StepIndicator from 'Event/template/Townhall/check-in/StepIndicator'
import CheckInPage from 'Event/template/Townhall/check-in/Page'
import Body from 'Event/Step3/TechCheck/Body'
import Buttons from 'Event/Step3/TechCheck/Buttons'
import AdditionalContent from 'Event/Step3/TechCheck/AdditionalContent'
import ConfigFields from 'organization/Event/TechCheckConfig/ConfigFields'

export type TownhallTechCheckProps = TechCheckProps & {
  settings: Townhall['techCheck']
}

export default function TechCheck(props: TownhallTechCheckProps) {
  return (
    <CheckInPage user={props.user}>
      <Container maxWidth="md">
        <StepIndicator step={3} />
        <ConfigFields />
        <Body />
        <Buttons />
        <AdditionalContent />
      </Container>
    </CheckInPage>
  )
}
